import { useState, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { ReactComponent as SuccessIcon } from "@/assets/icons/success.svg";
import { useCart } from "@/context/CartContext";
import "./Payment.css";

const PaymentSuccess: React.FC = () => {
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();
  const shoppingCartID = searchParams.get("ShoppingCartID");

  const [timeoutElapsed, setTimeoutElapsed] = useState(false);

  useEffect(() => {
    if (!shoppingCartID) {
      return;
    }
    clearCart();

    setTimeout(() => {
      setTimeoutElapsed(true);
    }, 3000);
  }, []);

  if (!shoppingCartID || timeoutElapsed) {
    return <Navigate to="/" replace />;
  }
  return (
    <div className="payment-container">
      <div className="payment-card">
        <div className="payment-content">
          <div className="flex justify-center">
            <SuccessIcon className="text-[#0B8F0B]" />
          </div>
          <div className="text-[#0b1a29] text-center text-xl font-bold">
            Plaćanje uspješno!
          </div>
          <div className="text-center">
            Preusmjeravanje natrag na aplikaciju...
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
